import { gql } from '@apollo/client';
import { PriceBookProductInfoShared } from '../fragments';

export default gql`
  query priceBookProducts($partnerLocationId: ID!, $productIds: [ID!]) {
    priceBookProducts(
      partnerLocationId: $partnerLocationId
      productIds: $productIds
    ) {
      ...PriceBookProductInfoShared
    }
  }
  ${PriceBookProductInfoShared}
`;
